import { Card, CardContent, Typography, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { colors } from "../../utils/colors";

interface StatCardProps {
  type: "available" | "unavailable";
  title: string;
  value: string | number;
  subtitle?: string;
  isSelected?: boolean;
  onClick?: () => void;
}

export const StatCard = ({
  type,
  title,
  value,
  subtitle,
  isSelected,
  onClick,
}: StatCardProps) => {
  const getIcon = () => {
    switch (type) {
      case "available":
        return <CheckCircleIcon sx={{ color: colors.success, fontSize: 20 }} />;
      case "unavailable":
        return <CancelIcon sx={{ color: colors.error, fontSize: 20 }} />;
      default:
        return null;
    }
  };

  const getValueColor = () => {
    return colors.primaryText;
  };

  return (
    <Card
      onClick={onClick}
      sx={{
        minWidth: 200,
        borderRadius: 2,
        boxShadow: isSelected
          ? "0 4px 12px rgba(0,0,0,0.15)"
          : "0 2px 8px rgba(0,0,0,0.1)",
        backgroundColor: isSelected ? colors.background : colors.cardBackground,
        border: isSelected
          ? `2px solid ${colors.volvoBlue}`
          : `1px solid ${colors.background}`,
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
          transform: onClick ? "translateY(-2px)" : "none",
        },
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
          {getIcon()}
          <Typography
            variant="body2"
            sx={{
              color: colors.primaryText,
              fontSize: "0.875rem",
              fontWeight: 400,
              ml: getIcon() ? 0.5 : 0,
            }}
          >
            {title}
          </Typography>
        </Box>
        <Typography
          variant="h4"
          sx={{
            color: getValueColor(),
            fontSize: "2rem",
            fontWeight: 600,
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};
